import DonutChart from './components/donut-chart.vue'
import BarChart from './components/bar-chart.vue'
import LineChart from './components/line-chart.vue'
import AreaChart from './components/area-chart.vue'

const VueMorris = {
  DonutChart, BarChart, LineChart, AreaChart
}

module.exports = VueMorris



// WEBPACK FOOTER //
// ./src/index.js